import {BaseParty} from './base-party.model';


export class Aka extends BaseParty {
    public akaId: number;
    constructor( ) {
      super();
    }
}
